import { Component, Input } from '@angular/core';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ama-loading-alert',
  templateUrl: './loading-alert.component.html',
  standalone: true,
  imports: [NgbAlert]
})
export class LoadingAlertComponent {
  @Input() sendingStatus = false;
  @Input() isDismissible = true;
  @Input() message = 'Loading...';

  constructor() {}
}
